import { render, staticRenderFns } from "./PrRow.vue?vue&type=template&id=2931e481"
import script from "./PrRow.vue?vue&type=script&lang=js"
export * from "./PrRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports